import {useEffect} from 'react'
import {FacebookMessageConfirmOrderTable} from '../table'
import {StyledFacebookMessageConfirmOrderWrapper} from './_styled'
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";

export const FacebookMessageConfirmOrderWrapper = ({...props}) => {
  const {data, methods} = useFacebookMessageConfirmOrder()
  
  useEffect(() => {
    methods.fetchOrigin()
    methods.fetchProductPrintSettings()
  }, [])

  return (
    <StyledFacebookMessageConfirmOrderWrapper {...props}>
      <FacebookMessageConfirmOrderTable rows={data.pages.list} />
    </StyledFacebookMessageConfirmOrderWrapper>
  )
}
